import { render, staticRenderFns } from "./icon-editor.vue?vue&type=template&id=09d3f1b4&scoped=true&"
import script from "./icon-editor.vue?vue&type=script&lang=js&"
export * from "./icon-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d3f1b4",
  null
  
)

export default component.exports